




















































import { Component, Vue } from 'vue-property-decorator'
import {
  Conditions,
  ImageSet
} from '../../modules/class/PdfDownload/Conditions'
import { DownloadLinkInfo } from '../../modules/class/Downloads'
import PdfList from '../../components/PdfLink/PdfList.vue'
import PdfItem from '../../components/PdfLink/PdfItem.vue'

interface DownloadLinkInfoWithImageSet extends DownloadLinkInfo {
  imageSet: ImageSet
}

@Component({
  components: { PdfList, PdfItem }
})
export default class PdfDownloadListWithImage extends Vue {
  // --------------------------------------------------------------------------------------------------------------------
  // data

  // 抽出条件（main.tsから連携される）
  private conditions: Conditions = new Conditions()
  private pdfList: DownloadLinkInfoWithImageSet[] = []

  // --------------------------------------------------------------------------------------------------------------------
  // methods

  /**
   * コンポーネントから渡された一覧を更新
   */
  private updatePdfList(data: DownloadLinkInfoWithImageSet[]) {
    for (const item of data) {
      const imageSet = this.conditions.imageList.find(
        (i) => i.documentId === item.entityId
      )
      if (imageSet) {
        item.imageSet = imageSet
      } else {
        item.imageSet = {
          documentId: 0,
          imagePath: '',
          imageAlt: '',
          description: ''
        }
      }
    }

    this.pdfList = data
  }
}
